import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { FocusTrapperFactory } from '../../../components/focus/focus-trapper-factory';
import { MenuPanelItem } from '../../../domain/menu.domain';
import { MobileFlyoutMenuNavContainer } from './mobile-flyout-menu.domain';

@Component({
  selector: 'td-wb-mobile-flyout-menu-nav',
  templateUrl: 'mobile-flyout-menu-nav.component.html',
  styleUrls: ['mobile-flyout-menu-nav.component.scss'],
  imports: [
    NgTemplateOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileFlyoutMenuNavComponent implements OnDestroy {

  static TRANSITION_DURATION: number = 250;

  @ViewChild('menuContainer', { static: true }) container: ElementRef;

  @Input()
  get opened(): boolean { return this._opened; }

  @Output() readonly openedChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  @ContentChild(TemplateRef, /* TODO: add static flag */ {}) content: TemplateRef<{$implicit: MenuPanelItem}>;

  @HostBinding('style.display')
  get menuDisplay(): string { return this._opened ? 'block' : 'none'; }

  @HostBinding('style.transitionDuration.ms')
    styleTransitionDuration: number = MobileFlyoutMenuNavComponent.TRANSITION_DURATION;

  @HostBinding('style.transform')
    styleTransform: string = 'translate3d(-100%, 0, 0)';

  @HostBinding('attr.aria-hidden')
    attrAriaHidden: string = 'true';

  menu: MenuPanelItem;

  private _opened: boolean = false;
  private overlayRefContainer: MobileFlyoutMenuNavContainer;

  constructor(private focusTrapperFactory: FocusTrapperFactory,
              private changeDetectorRef: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.dispose();
  }

  open(menu?: MenuPanelItem): void {
    if (!this._opened) {
      this.menu = menu;
      this.overlayRefContainer = new MobileFlyoutMenuNavContainer(this.container.nativeElement, this.focusTrapperFactory);
      this.toggle(true);
    }
  }

  close(): void {
    this.dispose();
    return this.toggle(false);
  }

  toggle(isOpen: boolean = !this.opened): void {
    if (this._opened !== isOpen) {
      this._opened = isOpen;

      this.styleTransform = this._opened ? 'none' : 'translate3d(-100%, 0, 0)';
      this.attrAriaHidden = this._opened ? 'false' : 'true';

      this.openedChange.emit(this._opened);
      this.changeDetectorRef.markForCheck();
    }
  }

  swipeLeft(): void {
    if (this.opened) {
      this.close();
    }
  }

  stopAnimation(): void {
    this.styleTransitionDuration = 0;
  }

  startAnimation(): void {
    this.styleTransitionDuration = MobileFlyoutMenuNavComponent.TRANSITION_DURATION;
  }

  moveTo(left: number): void {
    this.styleTransform = `translate3d(${left}px, 0, 0)`;
  }

  private dispose(): void {
    if (this.overlayRefContainer !== undefined) {
      this.overlayRefContainer.destroy();
      this.overlayRefContainer = undefined;
    }
  }
}
